import { render, staticRenderFns } from "./WholeDollarView.vue?vue&type=template&id=195cfecd&"
import script from "./WholeDollarView.vue?vue&type=script&lang=js&"
export * from "./WholeDollarView.vue?vue&type=script&lang=js&"
import style0 from "./WholeDollarView.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports